import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";

export default class List extends Component {


	constructor(props, context) {
		super(props);

		this.columnModel = [
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: (val, row) => {
					return <div style={{cursor:'pointer'}} onClick={() => this.select(row.text)}>{val}</div>
				}
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
		};
		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-programmepopup');
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'title', 'direction': 'asc'};
	}

	select(val) {
		this.props.onSelect(val);
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('programme.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('programme.change', this.changeListener);
	}


	render() {

		return (
			<Datagrid
				ref="datagrid"
				id="programmepopup"
				api="programme.getList"
				buttons={<h5>Vyberte šablonu programu</h5>}
				saveState={false}
				filters={['fulltext']}
				filter={this.filter}
				limit={10}
				columnModel={this.columnModel}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Programme/PickerList.js